export default "__VITE_ASSET__1a260829__"